var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as RA from 'fp-ts/ReadonlyArray';
import * as t from 'io-ts';
var TypeFromStringType = /** @class */ (function (_super) {
    __extends(TypeFromStringType, _super);
    function TypeFromStringType(name, is, validate, encode, props, keys, type, separator) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        _this.keys = keys;
        _this.type = type;
        _this.separator = separator;
        _this._tag = 'TypeFromStringType';
        return _this;
    }
    return TypeFromStringType;
}(t.Type));
export { TypeFromStringType };
export function make(props, keys, name, separator) {
    if (separator === void 0) { separator = '::'; }
    var pickedProps = Object.assign.apply(Object, __spreadArray([{}], keys.map(function (k) {
        var _a;
        return (_a = {}, _a[k] = props[k], _a);
    }), false));
    return new TypeFromStringType(name !== null && name !== void 0 ? name : 'typeFromString', function (u) { return t.UnknownRecord.is(u) && keys.every(function (k) { return props[k].is(u[k]); }); }, function (u, c) {
        return pipe(t.string.validate(u, c), E.chain(function (str) {
            var tokens = str.split(separator);
            if (tokens.length !== keys.length)
                return t.failure(u, c);
            return pipe(RA.zip(keys, tokens), RA.traverse(E.Applicative)(function (_a) {
                var k = _a[0], v = _a[1];
                return pipe(props[k].validate(v, t.appendContext(c, String(k), props[k])), E.map(function (r) { return [k, r]; }));
            }), E.map(RA.reduce({}, function (r, _a) {
                var _b;
                var k = _a[0], v = _a[1];
                return (__assign(__assign({}, r), (_b = {}, _b[k] = v, _b)));
            })));
        }));
    }, function (o) { return keys.map(function (k) { return props[k].encode(o[k]); }).join(separator); }, pickedProps, keys, t.type(pickedProps, name), separator);
}
export var empty = make({}, []);
export function singleton(key, type, name, separator) {
    var _a;
    return make((_a = {}, _a[key] = type, _a), [key], name, separator);
}
/**
 * Creates a new type which appends the key with the given type to the encoded value
 * @param key
 * @param type
 */
export var append = function (key, type) {
    return function (t) {
        var _a;
        return make(Object.assign((_a = {}, _a[key] = type, _a), t.props), __spreadArray(__spreadArray([], t.keys, true), [key], false), t.name, t.separator);
    };
};
/**
 * Creates a new type which prepends the key with the given type to the encoded value
 * @param key
 * @param type
 */
export var prepend = function (key, type) {
    return function (t) {
        var _a;
        return make(Object.assign((_a = {}, _a[key] = type, _a), t.props), __spreadArray([key], t.keys, true), t.name, t.separator);
    };
};
export var rename = function (name) {
    return function (t) {
        return make(t.props, t.keys, name, t.separator);
    };
};
export var separate = function (separator) {
    return function (t) {
        return make(t.props, t.keys, t.name, separator);
    };
};
